import { render } from "./BlogSingle.vue?vue&type=template&id=052e176e&ts=true"
import script from "./BlogSingle.vue?vue&type=script&lang=ts"
export * from "./BlogSingle.vue?vue&type=script&lang=ts"

import "./BlogSingle.vue?vue&type=style&index=0&id=052e176e&lang=scss"

import exportComponent from "/builds/saatsazov/saatsazov-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__